<template>
  <vue-perfect-scroll-bar class="scroll" :settings="settings">
    <slot />
  </vue-perfect-scroll-bar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    "vue-perfect-scroll-bar": VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        suppressScrollY: true
      }
    };
  }
};
</script>

<style>
.scroll {
  position: relative;
  height: 70px;
  white-space: nowrap;
}
</style>
